let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("RSFv0")).then(() => parcelRequire('dWQSr'));